<template>
    <div class="loading-progress">
        <ProgressBar :value="percentage" />

<!--        <Skeleton height="5rem" v-for="option in this.searchOptions" :key="option" style="margin-bottom: 20px"></Skeleton>-->
    </div>
</template>

<script>
import ProgressBar from 'primevue/progressbar';
// import Skeleton from 'primevue/skeleton';

export default {
    name: 'CreatorLoadingProgress',
    props: {
        percentage: {
            type: Number,
            required: true,
        },
        searchOptions: {
            type: Array,
            required: true,
        }
    },
    components: {
        ProgressBar,
        // Skeleton
    }
}
</script>